import { generateTransactionStatusId } from 'dashboard/lib/stubs/transaction-status';
import { generateTransactionTypeId } from 'dashboard/lib/stubs/transaction-type';
import {
  TransactionStatus,
  TransactionStatusAttributes,
  TransactionStatusState,
} from 'dashboard/models/transaction-status';
import { ApiModel } from 'lib/interfaces/api';

export function createPreviewTransactionStatus(
  attributes?: Partial<TransactionStatusAttributes>,
  id?: string,
  transactionTypeId?: string,
): TransactionStatus {
  return {
    id: id || generateTransactionStatusId(),
    type: ApiModel.TransactionStatus,
    attributes: {
      'deactivated-at': attributes?.['deactivated-at'] || '2019-09-20T09:30:12.000Z',
      'created-at': '2019-09-20T05:30:12.000Z',
      'updated-at': '2019-09-20T08:30:12.000Z',
      name: attributes?.['name'] || 'created',
      status: attributes?.['status'] || TransactionStatusState.Active,
      'display-name': attributes?.['name'] || 'created (txn type)',
    },
    relationships: {
      'transaction-type': {
        data: {
          type: ApiModel.TransactionType,
          id: transactionTypeId || generateTransactionTypeId(),
        },
      },
    },
  };
}
